import React from 'react';
import { Helmet } from 'react-helmet';

function Blog() {
    return (
        <>
            <Helmet>
                <title>Kai Cheng | Blog</title>
                <meta name='description' content='Kai Cheng | Blog' />
                <link rel='canonical' href='https://www.kaicheng.ca/blog/' />
            </Helmet>
            <h1 className='coming-soon'>Blog Coming Soon!</h1>
        </>
    );
}

export default Blog;
